







































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageShow from "@/components/ImageShow.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import {SiteEntity} from "@/entity/SiteEntity";

/**
 * Bu ekranın düzenlediği "site" ayarları. Kayıtta yalnızca bu anahtarlar
 * gönderilir; sunucu gönderilmeyenleri (ek kodlar, filigran vb.) korur.
 * Sitede hiç okunmayan "Sayfa Metinleri" alanları (bannerSlogan,
 * contactInfo, anasayfaBaslik… ve _en karşılıkları) kaldırıldı: panelden
 * değiştirilip sitede görünmemeleri "ayar yansımıyor" şikâyetine yol açıyordu.
 */
export class config {
    phone : string = "";
    phone2 : string = "";
    whatsapp : string = "";
    address : string = "";
    address2 : string = "";
    email : string = "";
    formEmail : string = "";
    workingHours : string = "";
    mapsUrl : string = "";
    mapsEmbedUrl : string = "";
    directionsUrl : string = "";
    instagram : string = "";
    facebook : string = "";
    youtube : string = "";
    linkedin : string = "";
    x : string = "";
    tiktok : string = "";
    smtpHost : string = "";
    smtpPort : string = "";
    smtpSecure : string = "";
    smtpUser : string = "";
    // Sunucu kayıtlı şifreyi asla döndürmez, "********" döner; bu değer
    // geri gönderilince şifre korunur (kayıt şifreyi silmesin diye).
    smtpPass : string = "";
    smtpFrom : string = "";
    smtpFromName : string = "";
}

/** Sunucunun "kayıtlı şifre var" işareti */
const PASS_MASK = "********";
const SMTP_KEYS = ["smtpHost", "smtpPort", "smtpSecure", "smtpUser", "smtpPass", "smtpFrom", "smtpFromName"];

/** HTML varlıklarını çözer (&amp; vb.); textarea içeriği çalıştırılmaz, yalnızca metin olur */
function decodeEntities(value: string): string {
    const el = document.createElement("textarea");
    el.innerHTML = value;
    return el.value;
}

/**
 * Yapıştırılan iframe HTML'inden ya da adresten harita adresini çıkarır.
 * Sitedeki Brand::mapsEmbedSrc() ile aynı kural: yalnızca
 * https://(www.)google.com/maps/embed… kabul edilir, gerisi sitede boş
 * harita demektir — müşteri kaydetmeden görsün.
 */
function extractEmbedSrc(raw: any): string {
    let value = String(raw || "").trim();
    if (value === "") {
        return "";
    }
    if (!/^(https?:)?\/\//i.test(value)) {
        // "data-src" ile karışmasın (sitedeki kural gibi); lookbehind eski Safari'de yok
        const match = value.match(/(?:^|[^\w-])src\s*=\s*"([^"]*)"/i)
            || value.match(/(?:^|[^\w-])src\s*=\s*'([^']*)'/i)
            || value.match(/(?:^|[^\w-])src\s*=\s*([^\s>"']+)/i);
        if (match) {
            value = match[1];
        } else if (/^(www\.)?google\.com\/maps\/embed/i.test(value)) {
            value = "https://" + value;
        } else {
            return "";
        }
    }
    value = decodeEntities(value).trim();
    if (value.indexOf("//") === 0) {
        value = "https:" + value;
    }
    if (value === "" || /[\s<>"'\\]/.test(value)) {
        return "";
    }
    let url: URL;
    try {
        url = new URL(value);
    } catch (e) {
        return "";
    }
    const host = url.hostname.toLowerCase();
    if (url.protocol !== "https:" || (host !== "www.google.com" && host !== "google.com")
        || url.username !== "" || url.password !== "" || url.port !== "" || url.search.length <= 1) {
        return "";
    }
    /*
     * URL() ":443"ü ve "/maps/embed/x.y" gibi yolları sessizce kabul ediyor;
     * site bunları reddediyor. Ham adres sitedeki kuralla denetlenir ki
     * önizleme "geçerli" deyip sitede harita boş kalmasın.
     */
    const rest = value.replace(/^https:\/\//i, "");
    const authority = rest.split(/[\/?#]/)[0];
    const rawPath = rest.substring(authority.length).split(/[?#]/)[0];
    if (/[:@]/.test(authority) || !/^\/maps\/embed(?:\/[A-Za-z0-9_-]+)*\/?$/.test(rawPath)) {
        return "";
    }
    return value;
}

/** base64url → UTF-8 metin (Google pb içindeki !2z… yer adı) */
function decodeBase64Utf8(value: string): string {
    let b64 = value.replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4 !== 0) {
        b64 += "=";
    }
    const binary = window.atob(b64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return new TextDecoder("utf-8").decode(bytes);
}

/**
 * Haritada işaretli yerin adı. Adres iğnesinde burada sokak/numara,
 * işletme kartında işletme adı yazar; müşteri yanlış yeri kaydetmeden fark etsin.
 */
function embedPlaceName(src: string): string {
    const match = src.match(/!1s0x[0-9a-f]+(?:%3A|:)0x[0-9a-f]+!2([sz])([^!&]+)/i);
    if (!match) {
        return "";
    }
    try {
        const text = match[1].toLowerCase() === "z"
            ? decodeBase64Utf8(match[2])
            : decodeURIComponent(match[2].replace(/\+/g, " "));
        return text.trim();
    } catch (e) {
        return "";
    }
}

function looksLikeAddress(text: string): boolean {
    return /\d/.test(text) && /(\bsk\b|\bsok|\bsokak|\bcad|\bcd\b|\bmah|\bno\s*[:.]?\s*\d|\/)/i.test(text);
}

function isGoogleMapsLink(value: string): boolean {
    return /^https:\/\/(maps\.app\.goo\.gl|goo\.gl\/maps|g\.page|g\.co\/kgs|(www\.)?google\.[a-z.]+\/maps|maps\.google\.[a-z.]+)/i.test(value);
}

interface TestResult {
    type: string;
    title: string;
    errorLabel: string;
    error: string;
    advice: string;
    details: string;
    visible: boolean;
}

@Component({
    components: {
        ImageUpload,
        ImageShow,
        Decimal,
        DeleteButton,EForm,Number,TextField,EnabledSwitch
    }
})
export default class SiteConfig extends  Vue{
    baseAction : string = ActionsEnum.Config;
    action : string = this.baseAction;
    data : config = new config();
    /** Sunucudaki (kayıtlı) değerler: test ve alıcı bilgisi bunlara göre */
    saved : config = new config();
    dialog : boolean = false;
    /** Formdaki verinin ait olduğu şube (sunucunun döndürdüğü _site_id) */
    loadedSiteId : number | null = null;
    loadedSiteName : string = "";
    loading : boolean = false;
    loadError : string = "";
    /** Üst üste binen yüklemelerde yalnızca sonuncusu forma yazılır */
    loadToken : number = 0;

    showPass : boolean = false;
    /** Maskeli şifre alanı yazmak için boşaltıldı (odaktan çıkınca boşsa maske geri gelir) */
    passEditing : boolean = false;
    /** Kullanıcı "Kayıtlı şifreyi sil"e bastı: boş alan kayıtta şifreyi siler */
    clearPassRequested : boolean = false;
    testTo : string = "";
    testing : boolean = false;
    testResult : TestResult | null = null;

    secureOptions = [
        {text: "Seçilmedi (varsayılan)", value: ""},
        {text: "TLS (port 587)", value: "tls"},
        {text: "SSL (port 465)", value: "ssl"},
        {text: "Yok (önerilmez)", value: "none"},
    ];

    get activeSiteId() : number | null {
        const id = this.$store.getters.activeSiteId;
        return id === null || id === undefined || id === "" ? null : window.Number(id);
    }

    /**
     * Form yalnızca yüklenen veri aktif şubeye aitse gösterilir; şube
     * değiştiğinde eski şubenin değerleri yeni şubeye kaydedilemez.
     * (Kayıt sonrası aynı şubenin yeniden yüklenmesinde form gizlenmez;
     * gizlenirse EForm'un "İşlem başarılı" bildirimi de kayboluyordu.)
     */
    get formReady() : boolean {
        return this.loadError === "" && this.loadedSiteId !== null
            && (this.activeSiteId === null || this.activeSiteId === this.loadedSiteId);
    }

    get loadedSite() : SiteEntity | null {
        const sites : SiteEntity[] = this.$store.getters.sites || [];
        return sites.find((s : SiteEntity) => window.Number(s.site_id) === this.loadedSiteId) || null;
    }

    /* ------------------------------------------------------------------
     * Form e-postası alıcısı — sunucudaki SiteContext::formEmail() sırası:
     * Şubeler'deki form e-postası → bu sayfadaki Form E-Posta → E-Posta
     * ---------------------------------------------------------------- */
    get formRecipient() : {email : string; source : string} {
        const site = this.loadedSite;
        if (site && String(site.form_email || "").trim() !== "") {
            return {email: String(site.form_email).trim(), source: "Şubeler ekranındaki “Form E-Posta Adresi”"};
        }
        if (this.saved.formEmail.trim() !== "") {
            return {email: this.saved.formEmail.trim(), source: "bu sayfadaki “Form E-Posta”"};
        }
        if (this.saved.email.trim() !== "") {
            return {email: this.saved.email.trim(), source: "bu sayfadaki “E-Posta”"};
        }
        return {email: "", source: ""};
    }

    get formEmailHint() : string {
        const site = this.loadedSite;
        if (site && String(site.form_email || "").trim() !== "") {
            return "Şubeler ekranında “Form E-Posta Adresi” (" + String(site.form_email).trim()
                + ") girili olduğu için iletişim formları oraya gider; bu alan kullanılmaz.";
        }
        return "Sitedeki iletişim formu mesajları bu adrese gönderilir.";
    }

    /* ------------------------------------------------------------------
     * Harita
     * ---------------------------------------------------------------- */
    get embedSrc() : string {
        return extractEmbedSrc(this.data.mapsEmbedUrl);
    }

    get embedStatus() : {cls : string; icon : string; text : string} | null {
        const raw = String(this.data.mapsEmbedUrl || "").trim();
        if (raw === "") {
            return {cls: "warning--text", icon: "mdi-alert", text: "Harita girilmemiş."};
        }
        if (this.embedSrc !== "") {
            return {cls: "success--text", icon: "mdi-check-circle",
                text: "Geçerli Google Haritalar yerleştirme kodu."};
        }
        if (isGoogleMapsLink(raw) && !/<iframe/i.test(raw)) {
            return {cls: "error--text", icon: "mdi-close-circle",
                text: "Bu bir paylaşım bağlantısı; aşağıdaki “Konum bağlantısı” kutusuna yapıştırın. "
                    + "Bu kutuya “Harita yerleştir” sekmesindeki HTML kodu gelir."};
        }
        return {cls: "error--text", icon: "mdi-close-circle",
            text: "Google Haritalar yerleştirme kodu tanınmadı; böyle kaydedilirse harita boş kalır. "
                + "Paylaş → Harita yerleştir → HTML'yi kopyala ile alınan kodun tamamını yapıştırın."};
    }

    get embedPlace() : {cls : string; icon : string; text : string} | null {
        if (this.embedSrc === "") {
            return null;
        }
        const name = embedPlaceName(this.embedSrc);
        if (name === "") {
            return null;
        }
        if (looksLikeAddress(name)) {
            return {cls: "warning--text", icon: "mdi-alert",
                text: "Harita bir adresi işaretliyor (“" + name + "”), işletmenizi değil. İşletme adınızın "
                    + "görünmesi için Google Haritalar'da işletmenizi aratıp açın ve kodu oradan alın."};
        }
        return {cls: "success--text", icon: "mdi-map-marker",
            text: "Haritada işaretli yer: " + name};
    }

    get mapsUrlHint() : {text : string; error : boolean} {
        const value = String(this.data.mapsUrl || "").trim();
        if (value === "") {
            return {text: "Örnek: https://maps.app.goo.gl/… — sitedeki konum bağlantıları ve yol tarifi bunu kullanır.", error: false};
        }
        if (/<iframe/i.test(value)) {
            return {text: "Buraya HTML kodu değil, “Bağlantıyı kopyala” ile alınan bağlantı gelir.", error: true};
        }
        if (!this.isHttps(value)) {
            return {text: "Bağlantı https:// ile başlamalı.", error: true};
        }
        if (!isGoogleMapsLink(value)) {
            return {text: "Google Haritalar bağlantısı gibi görünmüyor; yine de kaydedilebilir.", error: false};
        }
        return {text: "“Bağlantıyı dene” ile açılan sayfada işletmenizin göründüğünü kontrol edin.", error: false};
    }

    get directionsHint() : {text : string; error : boolean} {
        const value = String(this.data.directionsUrl || "").trim();
        if (value !== "" && !this.isHttps(value)) {
            return {text: "Bağlantı https:// ile başlamalı.", error: true};
        }
        return {text: "“Yol Tarifi Al” düğmesi önce bu bağlantıyı, boşsa konum bağlantısını, o da boşsa "
                + "haritadaki konumu kullanır. Genellikle boş bırakılır.", error: false};
    }

    isHttps(value : any) : boolean {
        return /^https:\/\/[^\s"'<>]+$/i.test(String(value || "").trim());
    }

    /* ------------------------------------------------------------------
     * SMTP
     * ---------------------------------------------------------------- */
    get passIsMask() : boolean {
        return this.data.smtpPass === PASS_MASK;
    }

    /** Kayıtlı şifre vardı ama alan boşaltıldı: kaydedilirse şifre silinir */
    get passWillBeCleared() : boolean {
        return this.saved.smtpPass === PASS_MASK && String(this.data.smtpPass || "") === "" && !this.passEditing;
    }

    get passHint() : string {
        if (this.passIsMask) {
            return "Kayıtlı şifre var (gizli). Değiştirmek için yeni şifreyi yazın.";
        }
        if (this.passEditing && String(this.data.smtpPass || "") === "") {
            return "Yeni şifreyi yazın; boş bırakırsanız kayıtlı şifre korunur.";
        }
        if (this.passWillBeCleared) {
            return "Kaydederseniz kayıtlı şifre silinir.";
        }
        return "Gmail ve Yandex'te hesap şifresi değil, uygulama şifresi girilir.";
    }

    get portHint() : string {
        const port = String(this.data.smtpPort || "").trim();
        const secure = this.data.smtpSecure;
        if (port !== "" && !/^\d{1,5}$/.test(port)) {
            return "Port yalnızca rakam olmalı (örn. 587).";
        }
        if (port === "465" && secure === "tls") {
            return "465 portu genellikle SSL ile kullanılır.";
        }
        if (port === "587" && secure === "ssl") {
            return "587 portu genellikle TLS ile kullanılır.";
        }
        return "587 (TLS) ya da 465 (SSL). Boşsa güvenlik türüne göre seçilir.";
    }

    /*
     * Maskeli alana tıklayıp yazınca yeni şifre "********abc" olarak
     * kaydedilirdi. Odaklanınca alan boşaltılır; hiçbir şey yazılmadan
     * çıkılırsa (ya da Enter ile kaydedilirse) maske geri konur ki kayıtlı
     * şifre yanlışlıkla silinmesin.
     */
    onPassFocus() {
        if (this.passIsMask) {
            this.data.smtpPass = "";
            this.passEditing = true;
        }
    }

    restoreMaskIfEmpty() {
        if (this.passEditing && String(this.data.smtpPass || "") === "" && !this.clearPassRequested) {
            this.data.smtpPass = PASS_MASK;
        }
        this.passEditing = false;
    }

    clearStoredPass() {
        this.clearPassRequested = true;
        this.passEditing = false;
        this.data.smtpPass = "";
    }

    applyPreset(name : string) {
        if (name === "gmail") {
            this.data.smtpHost = "smtp.gmail.com";
            this.data.smtpPort = "587";
            this.data.smtpSecure = "tls";
        } else if (name === "yandex") {
            this.data.smtpHost = "smtp.yandex.com.tr";
            this.data.smtpPort = "465";
            this.data.smtpSecure = "ssl";
        }
    }

    smtpSnapshot(source : config) : string {
        const values : any = {};
        SMTP_KEYS.forEach((key : string) => values[key] = String((source as any)[key] || "").trim());
        return JSON.stringify(values);
    }

    get smtpDirty() : boolean {
        return this.smtpSnapshot(this.data) !== this.smtpSnapshot(this.saved);
    }

    get testToValid() : boolean {
        const to = String(this.testTo || "").trim();
        return to === "" || /^[^\s@<>"']+@[^\s@<>"']+\.[^\s@<>"']+$/.test(to);
    }

    get testToHint() : string {
        if (!this.testToValid) {
            return "Geçerli bir e-posta adresi yazın.";
        }
        return this.formRecipient.email
            ? "Boş bırakılırsa form e-postalarının gittiği adrese (" + this.formRecipient.email + ") gönderilir."
            : "Test e-postasının gönderileceği adres.";
    }

    get canTest() : boolean {
        return !this.testing && !this.smtpDirty && this.testToValid && this.formReady;
    }

    /** Sık görülen SMTP hatalarına müşterinin anlayacağı açıklama (PHPMailer TR/EN metinleri) */
    errorAdvice(error : string) : string {
        const e = error.toLowerCase();
        if (/authenticat|oturum açılamadı|535|534|username and password|invalid login|auth/.test(e)) {
            return "Kullanıcı adı ya da şifre kabul edilmedi. Gmail ve Yandex'te normal hesap şifresi değil, "
                + "“uygulama şifresi” gerekir.";
        }
        if (/could not connect|connect\(\)|bağlanılamadı|timed out|timeout|getaddrinfo|connection refused|network|unreachable/.test(e)) {
            return "Sunucuya bağlanılamadı. Sunucu adını, portu ve güvenlik türünü kontrol edin (587 → TLS, "
                + "465 → SSL). Barındırma firması dışarıya e-posta bağlantısını engelliyor olabilir.";
        }
        if (/certificate|ssl|tls|crypto/.test(e)) {
            return "Güvenli bağlantı kurulamadı. Güvenlik türünü (TLS/SSL) ve portu değiştirip tekrar deneyin.";
        }
        if (/sender|from address|gönderme başarısız|veri kabul edilmedi|553|550|not owned|mail from/.test(e)) {
            return "Sunucu gönderen adresini ya da mesajı kabul etmedi. “Gönderen adresi”ni boş bırakın ya da "
                + "giriş yapılan hesapla aynı adresi yazın.";
        }
        if (/recipient|rcpt|alıcı|geçersiz e-posta/.test(e)) {
            return "Alıcı adresi reddedildi; adresi kontrol edin.";
        }
        return "";
    }

    async sendTest() {
        if (!this.canTest) {
            return;
        }
        // Test, formun ait olduğu şubenin ayarlarıyla yapılmalı
        if (this.activeSiteId !== null && this.activeSiteId !== this.loadedSiteId) {
            return;
        }
        this.testing = true;
        this.testResult = null;
        const payload = new FormData();
        const to = String(this.testTo || "").trim();
        if (to !== "") {
            payload.append("to", to);
        }
        try {
            const response = await this.$http.post("mailtest", payload);
            this.testResult = this.buildTestResult(response.data, "");
        } catch (e) {
            const body = e && e.response ? e.response.data : null;
            if (body && typeof body === "object" && (body.ok !== undefined || body.error !== undefined)) {
                this.testResult = this.buildTestResult(body, "");
            } else {
                this.testResult = this.buildTestResult(null, this.errorText(e));
            }
        } finally {
            this.testing = false;
        }
    }

    buildTestResult(body : any, requestError : string) : TestResult {
        if (!body || typeof body !== "object") {
            return {type: "error", title: "Test yapılamadı.", errorLabel: "Hata",
                error: requestError || "Sunucudan beklenmeyen yanıt geldi.",
                advice: "", details: "", visible: true};
        }
        const ok = body.ok === true || body.ok === 1 || body.ok === "1" || body.ok === "true";
        const error = String(body.error || "").trim();
        const to = String(body.to || "").trim();
        const parts : string[] = [];
        if (body.host) {
            parts.push("Sunucu: " + body.host + (body.port ? ":" + body.port : "")
                + (body.secure ? " (" + String(body.secure).toUpperCase() + ")" : ""));
        }
        if (body.user) {
            parts.push("Kullanıcı: " + body.user);
        }
        if (body.from) {
            parts.push("Gönderen: " + body.from);
        }
        const details = parts.join(" · ");
        if (ok && error !== "") {
            // Yerel ortamda Mailer gerçekten göndermez
            return {type: "info", title: "Test tamamlandı ancak e-posta gönderilmedi" + (to ? " (" + to + ")" : "") + ".",
                errorLabel: "Not", error: error, advice: "", details: details, visible: true};
        }
        if (ok) {
            return {type: "success",
                title: "Test e-postası gönderildi" + (to ? ": " + to : "") + ". Gelen kutusunu ve gereksiz (spam) klasörünü kontrol edin.",
                errorLabel: "", error: "", advice: "", details: details, visible: true};
        }
        return {type: "error", title: "Test e-postası gönderilemedi" + (to ? " (" + to + ")" : "") + ".",
            errorLabel: "Hata", error: error || "Sunucu hata ayrıntısı vermedi.", advice: this.errorAdvice(error),
            details: details, visible: true};
    }

    errorText(e : any) : string {
        let text = "";
        try {
            // Doğrulama hataları {messages:[…]} olarak gelir; errorHandler sonuna " - " ekliyor
            text = String(this.$helper.errorHandler(e) || "").replace(/\s*-\s*$/, "");
        } catch (ignored) {
            text = "";
        }
        if (!text && e && e.response) {
            text = "Sunucu hatası (HTTP " + e.response.status + ")";
        }
        if (!text && e && e.message) {
            text = e.message;
        }
        return text || "Sunucuya ulaşılamadı.";
    }

    async get(){
        const token = ++this.loadToken;
        this.loading = true;
        this.loadError = "";
        try{
            let response = await this.$http.get(this.action);
            if(token !== this.loadToken){
                return;
            }
            const source = response.data && typeof response.data === "object" ? response.data : {};
            const fresh : any = new config();
            Object.keys(fresh).forEach((key:string)=>{
                const value = source[key];
                if(value !== undefined && value !== null && typeof value !== "object"){
                    fresh[key] = String(value);
                }
            });
            this.data = fresh;
            this.saved = Object.assign(new config(), fresh);
            this.showPass = false;
            this.passEditing = false;
            this.clearPassRequested = false;
            this.loadedSiteId = source._site_id !== undefined && source._site_id !== null
                ? window.Number(source._site_id)
                : (this.activeSiteId !== null ? this.activeSiteId : 0);
            this.loadedSiteName = String(source._site_name || "");
            if(this.activeSiteId !== null && this.loadedSiteId !== this.activeSiteId){
                // Sunucu başka şubeyi döndürdü (ör. seçili şube silinmiş)
                this.loadError = "Sunucu seçili şubeyi tanımadı; üstteki şube seçicisinden şubeyi yeniden seçin.";
            }
        }catch (e) {
            if(token === this.loadToken){
                this.loadedSiteId = null;
                this.loadError = this.$helper.errorHandler(e) || "Sunucuya ulaşılamadı.";
            }
        }finally {
            if(token === this.loadToken){
                this.loading = false;
            }
        }
    }

    @Watch("$store.getters.activeSiteId")
    onActiveSiteChanged(){
        if(this.activeSiteId !== null && this.activeSiteId === this.loadedSiteId && !this.loading){
            return;
        }
        this.loadedSiteId = null;
        this.data = new config();
        this.saved = new config();
        this.testResult = null;
        this.testTo = "";
        this.get();
    }

    created(){
        this.get();
    }
};
